import { useEffect, useState } from 'react'
import HomeService from '../services/homeService'

/**
 * The words for an active count result: "42 active pipelines", "2000+
 * active pipelines" when the count stopped early, plain "Active pipelines"
 * while loading or when it could not be counted.
 *
 * @param {{count: number, complete: boolean}|null} result
 */
export const activePipelinesLabel = (result) => {
    if (!result) return 'Active pipelines'
    const n = `${result.count}${result.complete ? '' : '+'}`
    return `${n} active pipeline${
        result.count === 1 && result.complete ? '' : 's'
    }`
}

/**
 * How many pipelines have `status`, counted in the background by the count
 * endpoint: the Pipelines list's total ("1-50 of 2,211") and Home's
 * Pipelines card.
 *
 * Null while loading, when the count failed, or when `enabled` is false (a
 * user who cannot open Pipelines is never asked for it). A change of
 * `reloadKey` counts again (after a refresh or a delete).
 *
 * @param {'active'|'inactive'} status
 * @param {boolean} [enabled]
 * @param {*} [reloadKey]
 * @returns {{count: number, complete: boolean}|null}
 */
const usePipelineCount = (status, enabled = true, reloadKey = 0) => {
    const [result, setResult] = useState(null)

    useEffect(() => {
        if (!enabled) return undefined
        let live = true
        setResult(null)
        HomeService.pipelineCount(status)
            .then((r) => live && setResult(r))
            .catch(() => live && setResult(null))
        return () => {
            live = false
        }
    }, [status, enabled, reloadKey])

    return enabled ? result : null
}

/** The active pipelines' count, for Home's Pipelines card. */
export const useActivePipelineCount = (enabled) =>
    usePipelineCount('active', enabled)

export default usePipelineCount
